(function () {
  'use strict';

  /* ── sommaire ── */
  function buildTOC() {
    const contentEl = document.querySelector('.art-content__body');
    const tocList = document.getElementById('art-toc-list');
    if (!contentEl || !tocList) return;

    const headings = contentEl.querySelectorAll('h2');
    if (headings.length === 0) {
      const sidebar = document.querySelector('.art-sidebar');
      if (sidebar) sidebar.style.display = 'none';
      return;
    }

    headings.forEach(function (h, i) {
      if (!h.id) h.id = 'section-' + (i + 1);
      var li = document.createElement('li');
      li.className = 'art-toc__item';
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.className = 'art-toc__link';
      a.textContent = h.textContent;
      li.appendChild(a);
      tocList.appendChild(li);
    });

    /* IntersectionObserver for active state */
    var tocLinks = tocList.querySelectorAll('.art-toc__link');
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            tocLinks.forEach(function (l) { l.classList.remove('art-toc__link--active'); });
            var active = tocList.querySelector('a[href="#' + entry.target.id + '"]');
            if (active) active.classList.add('art-toc__link--active');
          }
        });
      },
      { rootMargin: '0px 0px -70% 0px', threshold: 0 }
    );

    headings.forEach(function (h) { observer.observe(h); });
  }

  /* ── Copy Link ── */
  function initCopyLink() {
    var btn = document.getElementById('art-copy-link');
    if (!btn) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      navigator.clipboard.writeText(window.location.href).then(function () {
        var icon = btn.querySelector('i');
        if (icon) {
          icon.className = 'fa-solid fa-check';
          setTimeout(function () { icon.className = 'fa-solid fa-link'; }, 2000);
        }
      });
    });
  }

  /* ── Sticky sidebar offset (adapts to header visibility) ── */
  function initStickyOffset() {
    var header = document.querySelector('.shopify-section-header-sticky, .section-header');
    var sidebar = document.querySelector('.art-sidebar');
    if (!header || !sidebar) return;

    var update = function () {
      var hidden = header.classList.contains('shopify-section-header-hidden');
      var height = hidden ? '0px' : (getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '0px');
      sidebar.style.setProperty('--sidebar-offset', height);
    };

    new MutationObserver(update).observe(header, { attributes: true, attributeFilter: ['class'] });
    update();
  }

  /* ── Inline CTA replacement ── */
  function initInlineCTAs() {
    var body = document.querySelector('.art-content__body');
    if (!body) return;

    var pattern = /<p>\s*\[CTA-DARK-(\w+)\]\s*<\/p>|\[CTA-DARK-(\w+)\]/g;
    var html = body.innerHTML;
    var hasMatch = false;

    html = html.replace(pattern, function (match, m1, m2) {
      var id = m1 || m2;
      var tpl = document.querySelector('template[data-cta-type="dark"][data-cta-id="' + id + '"]');
      if (!tpl) return match;
      hasMatch = true;
      return tpl.innerHTML;
    });

    if (hasMatch) body.innerHTML = html;
  }

  /* ── Parallax on CTA Dark circles ── */
  function initParallaxCTAs() {
    var ctas = document.querySelectorAll('.art-cta-dark');
    if (!ctas.length) return;

    var active = new Set();

    function onScroll() {
      active.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var offset = rect.top + rect.height / 2 - window.innerHeight / 2;
        el.style.setProperty('--scroll-y', offset + 'px');
      });
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          active.add(entry.target);
        } else {
          active.delete(entry.target);
        }
      });

      if (active.size > 0) {
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      } else {
        window.removeEventListener('scroll', onScroll);
      }
    });

    ctas.forEach(function (el) { observer.observe(el); });
  }

  /* ── Init ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initInlineCTAs();
      buildTOC();
      initCopyLink();
      initStickyOffset();
      initParallaxCTAs();
    });
  } else {
    initInlineCTAs();
    buildTOC();
    initCopyLink();
    initStickyOffset();
    initParallaxCTAs();
  }
})();
